import {Component, Inject, LOCALE_ID} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-login-credentials-support-article',
    template: `
        <ng-container i18n="@@support.articles.loginCredentials">
            <p>We want to give organizations the freedom to provide login details to their students in the way and at the time they choose. <strong>That is why we do not send the login details to the students by default.</strong></p>
            <p>The tracking platform has many useful tools to provide the login details to your students.</p>

            <h2>Login cards</h2>
            <p>Login cards are handy cards that can be printed and distributed to the students.</p>
            <p>Each card contains the student's login details and short instructions for logging in.</p>
            <p>You can either print the cards of an entire class at once, or the card of one individual student.</p>

            <h3>For an entire class</h3>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Classes Overview</a>.</span>
                </li>
                <li>
                    <span>Find the class in the list or use the search field to find the class.</span>
                </li>
                <li>
                    <span>Click on the name of the class.</span>
                </li>
                <li>
                    <div>
                        <p>Click on the <strong>Login cards</strong> button at the top.</p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/classLoginCredentials.png" />
                        </p>
                    </div>
                </li>
                <li>
                    <span>A PDF file will be downloaded. You can open and print this file.</span>
                </li>
            </ol>

            <h3>For one student</h3>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Students Overview</a>.</span>
                </li>
                <li>
                    <span>Find the student in the list or use the search field to find the student.</span>
                </li>
                <li>
                    <span>
                        Click the three dots on the right side of the student.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/individualLoginCard.png" />
                    </span>
                </li>
                <li>
                    <div>
                        <p>Click on <strong>Download login card</strong> in the menu that opens.</p>
                    </div>
                </li>
                <li>
                    <span>A PDF file will be downloaded. You can open and print this file.</span>
                </li>
            </ol>

            <h2>Student list</h2>
            <p>The student list is a handy file that shows all the students of a class and their login details in a table.</p>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Classes Overview</a>.</span>
                </li>
                <li>
                    <span>Find the class in the list or use the search field to find the class.</span>
                </li>
                <li>
                    <span>Click on the name of the class.</span>
                </li>
                <li>
                    <div>
                        <p>Click on the <strong>Student list</strong> button at the top.</p>
                        <p>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/classLoginCredentials.png" />
                        </p>
                    </div>
                </li>
                <li>
                    <span>A PDF file will be downloaded. You can open and print this file.</span>
                </li>
            </ol>

            <h2>E-mail</h2>
            <p>After enrolling students you can send their login details by email. The only condition is, of course, that their e-mail address was entered when enrolling.</p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/organizationOrderConfirmation.png" />
            </figure>
            <p>After you close the registration window, the login cannot be sent by e-mail anymore. It is of course always possible to use the <strong>Reset password</strong> function to create and send a new password.</p>
            <p>
                <a
                    routerLink="/support/organizations/students/reset-password"
                    mat-stroked-button
                    color="primary"
                    class="supportLink"
                >Reset a student's password</a>
            </p>
        </ng-container>
    `
})
export class LoginCredentialsSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
